export default "__VITE_ASSET__234fc3f6__"